// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateFailedModeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'failureMode',
    type: actions.UPDATE_CLAIM_PIP_FAILED_MODE
});

export const updateDownTimeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'downtime',
    type: actions.UPDATE_CLAIM_PIP_DOWN_TIME
});

export const updatePipClaimFailedArea = value => ({
    property: 'failureArea',
    type: actions.UPDATE_CLAIM_PIP_FAILED_AREA,
    value
});

export const updatePipClaimPartSerialNumber = value => ({
    property: 'failurePartSerialNumber',
    type: actions.UPDATE_CLAIM_PIP_PART_SERIAL_NUMBER,
    value
});

export const updatePipClaimFailedModeComments = value => ({
    property: 'failureModeComments',
    type: actions.UPDATE_CLAIM_PIP_FAILED_MODE_COMMENTS,
    value
});

export const updatePipClaimDtacCase = value => ({
    property: 'dtacCase',
    type: actions.UPDATE_CLAIM_PIP_DTAC_CASE,
    value
});

export const updatePipClaimDtacSolution = value => ({
    property: 'dtacSolution',
    type: actions.UPDATE_CLAIM_PIP_DTAC_SOLUTION,
    value
});

export const updatePipClaimOperatorsComplaint = value => ({
    property: 'operatorsComplaint',
    type: actions.UPDATE_CLAIM_PIP_OPERATORS_COMPLAINT,
    value
});

export const updatePipClaimComplaintCause = value => ({
    property: 'causeOfComplaining',
    type: actions.UPDATE_CLAIM_PIP_COMPLAINT_CAUSE,
    value
});

export const updatePipClaimComplaintCorrection = value => ({
    property: 'howWasComplaintCorrected',
    type: actions.UPDATE_CLAIM_PIP_COMPLAINT_CORRECTION,
    value
});

export const updatePipClaimOperatorComments = value => ({
    property: 'comments',
    type: actions.UPDATE_CLAIM_PIP_OPERATORS_COMMENTS,
    value
});

export const updatePipClaimBasisForSettlement = value => ({
    property: 'basisForSettlement',
    type: actions.UPDATE_CLAIM_PIP_BASIS_FOR_SETTLEMENT,
    value
});



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/failure-panel.js